import React from "react";
import PropTypes from "prop-types";
import {
    Form,
    Card,
    Button,
    List as AntList,
    Modal,
    message,
    Input,
    // Col
} from "antd";
import "styles/form.css";
import { Table } from "components";
import { getErrorOnField, submitForm, fieldGenerator } from "utilities/form";
import { List, Map, OrderedMap } from "immutable";
import { INPUTS } from "constants/form-fields";
import { INPUT_TYPES } from "constants";
import moment from "moment";
import PdDocumentUploadForm from "forms/pd-document-upload-form";
import PDBrandsTable from "forms/pd-brands-table-form";
import PDBankDetailsTable from "forms/pd-bank-details-table-form";
import { fetchCaseDetail } from "../../store/actions";
import { QuestionareService } from "services";
const BRANDS_COLS = OrderedMap({
    Brand_Name: {
        title: "Brand Name",
        dataIndex: "Brand_Name",
        key: "name"
    },
    Distributor_Name: {
        title: "Distributor Name",
        dataIndex: "Distributor_Name",
        key: "distributor"
    },
    Percent_Sale: {
        title: "Percent Sale",
        dataIndex: "Percent_Sale",
        key: "perc_sale"
    }
});

const BANK_DETAILS_COLS = OrderedMap({
    Account_Number: {
        title: "Account Number",
        dataIndex: "Account_Number",
        key: "Account_Number"
    },
    IFSC_Code: {
        title: "IFSC Code",
        dataIndex: "IFSC_Code",
        key: "IFSC_Code"
    }
});

const ListItem = AntList.Item;
class QuestionareList extends React.PureComponent {
    state = {
        questionnaire: this.props.questionare,
        editMode: false,
        bankDetailModal: false,
        productModal: false,
        financialDetailsData: [],
        otherGroupCompaniesData: [],
        fetchedQuestionnaireData: false,
        fetchedOtherCompaniesData: false
    };
    componentDidMount() {
        this.updateSectionData("financial_details", "financialDetailsData", "fetchedQuestionnaireData");
        this.updateSectionData("other_group_companies", "otherGroupCompaniesData", "fetchedOtherCompaniesData");
    }
    
    componentDidUpdate(prevProps) {
        const sectionCols = prevProps?.questionare?.getIn(["financial_details", "columns"])  || [];
        if (
            this.state.financialDetailsData.length === 0 &&
          sectionCols.length !== 0 &&
          !this.state.fetchedQuestionnaireData
        ) {
            this.updateSectionData("financial_details", "financialDetailsData", "fetchedQuestionnaireData", prevProps);
        }
        if (
            this.state.otherGroupCompaniesData.length === 0 &&
          sectionCols.length !== 0 &&
          !this.state.fetchedOtherCompaniesData
        ) {
            this.updateSectionData("other_group_companies", "otherGroupCompaniesData", "fetchedOtherCompaniesData", prevProps);
        }
    }
    
    updateSectionData(sectionKey, stateKey, fetchedKey, prevProps = null) {
        const sectionCols = prevProps
            ? prevProps?.questionare?.getIn([sectionKey, "columns"]) : this.props?.questionare?.getIn([sectionKey, "columns"]) || [];
        const sectionResp = prevProps
            ? prevProps?.questionare?.getIn([sectionKey, "response"]) : this.props?.questionare?.getIn([sectionKey, "response"]) || [];
    
        if (
            this.state[stateKey].length === 0 &&
          sectionCols.length !== 0 &&
          !this.state[fetchedKey]
        ) {
            const row_keys = sectionCols.map((el) => el?.replace(/ /g, "_")?.toLowerCase());
            let tableData = [];
    
            if (sectionResp.length === 0) {
                tableData.push({
                    s_no: 0,
                    ...Object.fromEntries(row_keys.map((key) => [key, ""])),
                });
            } else if (sectionResp.length > 0) {
                let rowDataObject = {};
                tableData = sectionResp.map((_, index) => {
                    rowDataObject = { ...rowDataObject, s_no: index, ..._ };
                    return rowDataObject;
                });
            }
    
            this.setState({
                [stateKey]: tableData,
                [fetchedKey]: true,
            });
        }
    }
      
    docTypes = {};
    currentType = "";

    fieldGenerator = fieldGenerator.bind(this.props.form);
    getErrorOnField = getErrorOnField.bind(this.props.form);

    submitForm = submitForm.bind(this.props.form, values => {
        let questionnaire = this.state.questionnaire;
        let metaInfo = questionnaire.get("meta_info");
        questionnaire = questionnaire.set("meta_info", {
            lat: null,
            sno: 1,
            long: null,
            page: 1,
            type: "HIDDEN",
            category: "Business Details",
            started_by: metaInfo.started_by ? metaInfo.started_by : this.props.userId,
            started_on: metaInfo.started_on ? metaInfo.started_on : new Date().toISOString(),
            updated_by: this.props.userId,
            updated_on: new Date().toISOString(),
            submitted_by: this.props.userId,
            submitted_on: new Date().toISOString(),
        });
        if (
            values.mother_name && !values.mother_name?.trim() ||
            values.home_address && !values.home_address?.trim() ||
            values.shop_office_Address && !values.shop_office_Address?.trim() ||
            values.key_risk_foreseen && !values.key_risk_foreseen?.trim() || 
            values.supporting_remarks && !values.supporting_remarks?.trim()
        ) {
            message.error("Please fill in all required fields.");
            return;
        }
        if(values.net_monthly_income >5 || values.net_monthly_income<=3){
            message.error("Net Monthly Income must be greater than 3 and up to 5 Lakhs.")
            return;
        }
        const personal_details_documents = questionnaire.getIn(["personal_details_documents", "response", "proof_doc", "file"]);
        const shop_office_documents = questionnaire.getIn(["shop_office_documents", "response", "proof_doc", "file"]);
        if(personal_details_documents?.length!==0){
            values.personal_details_documents_reason = "";
        }
        if(shop_office_documents?.length!==0){
            values.shop_office_documents_reason = "";
        }
        if(personal_details_documents?.length===0 && !values?.personal_details_documents_reason?.trim() || shop_office_documents?.length === 0 && !values.shop_office_documents_reason?.trim()){
            message.error("Please upload the Proof document or submit reason for not submitting proof");
            return;
        }
        questionnaire = questionnaire.setIn(["financial_details", "response"], this.state.financialDetailsData);
        questionnaire = questionnaire.setIn(["other_group_companies", "response"], this.state.otherGroupCompaniesData);
        Object.keys(values)
            .filter(_ => !["shop_photos", "applicant_photo", "cheque", "top_brands_dealing_in", "bank_details", "personal_details_documents", "shop_office_documents"].includes(_))
            .map(_ => {
                questionnaire = questionnaire.withMutations(__ =>
                    __.setIn([_, "response"], values[_])
                );
            });
        this.props.updateCaseQuestionnaire(questionnaire);
    });

    onFileUploadComplete = () => { };

    getExtra = (key) => {
        return (
            <Button
                key={"upload"}
                onClick={() => {
                    this.currentType = key;
                    this.setState({
                        openDocModal: true
                    });
                }}
                disabled={this.props.recreditViewOnlyPermission}
            >
                Add Document
            </Button>
        );
    };

    toggleProductModal = () => {
        this.setState({
            productModal: !this.state.productModal
        });
    };

    toggleBankDetailModal = () => {
        this.setState({
            bankDetailModal: !this.state.bankDetailModal
        });
    }

    updateBrands = values => {
        const brands = Object.keys(values).map(_ => values[_]);
        this.setState({
            productModal: false,
            questionnaire: this.state.questionnaire.setIn(
                ["top_brands_dealing_in", "response"],
                brands
            )
        });
    };

    updateBankDetails = values => {
        const brands = Object.keys(values).map(_ => values[_]);
        this.setState({
            productModal: false,
            questionnaire: this.state.questionnaire.setIn(
                ["bank_details", "response"],
                brands
            )
        });
    };

    BrandBtn = (
        <Button onClick={this.toggleProductModal} disabled={this.props.recreditViewOnlyPermission}>{"Add Products"}</Button>
    );

    BankBtn = (
        <Button onClick={this.toggleBankDetailModal} disabled={this.props.recreditViewOnlyPermission}>{"Add Bank Details"}</Button>
    );


    getQuestionnaire(questionnaire) {
        const q = questionnaire.groupBy(_ => _.category).mapEntries(([k, v]) => {
            v = new OrderedMap({
                [k]: {
                    sno:10,
                    page: v.toList().getIn(["0", "page"], 1),
                    type:"LABEL",
                    label:k,
                    placeholder: k,
                    category:k
                }
            }).merge(v);
            
            return [k, v];
        }).flatten();
        return q;
    }

    onChange=(item, file)=>{
        let filterdFileArr = item.file.filter((_) => _ !== file);
        this.setState({
            questionnaire: this.state.questionnaire.withMutations(_ =>
                _.setIn(
                    [item?.doc_type, "response", item.key, "file"],
                    filterdFileArr
                )
            )
        });
    }
    handleDeleteRow = (index, sectionKey) => {
        this.setState((prevState) => {
            const updatedData = [...prevState[sectionKey]];
            updatedData.splice(index, 1); 
            return { [sectionKey]: updatedData };
        });
    };
    handleAddRow = (columns, sectionKey) => {
        let row_keys = [];
        let tableRow = [];
        columns?.forEach((el) => {
            const formattedKey = el?.replace(/ /g, "_")?.toLowerCase();
            row_keys.push(formattedKey);
        });
        tableRow.push({
            ...Object.fromEntries(row_keys.map((key) => [key, ""])),
        });
        this.setState((prevState) => {
            const newRow = {
                s_no: prevState[sectionKey].length,
                ...tableRow[0]
            };
            const updatedData = [...prevState[sectionKey], newRow];
            return { [sectionKey]: updatedData };
        });
    };
    renderTableColumns(data, sectionKey) {
        const columnsData = data?.columns || [];
        const tableStateName = sectionKey;
        const handleValueChange = (index, value, key) => {
            this.setState((prevState) => {
                const updatedData = [...prevState[tableStateName]];
                if (updatedData[index]) {
                    updatedData[index][key] = value;
                }
                return { [tableStateName]: updatedData };
            });
        };
        let columnsOrderedMap = new OrderedMap();
       
        columnsData.forEach((el) => {
            const formattedKey = el?.replace(/ /g, "_")?.toLowerCase();
            // row_keys.push(formattedKey);
          
            columnsOrderedMap = columnsOrderedMap.set(formattedKey, {
                title: el,
                dataIndex: formattedKey,
                key: formattedKey,
                width: 100,
                align: "center",
                render: (text, record, index) => {
                    return (
                        <Input
                            // style={{ width: 200 }}
                            // type={!["Latest FY Turnover (Lakhs)"].includes(el) ? "text" : "Number"}
                            type={
                                sectionKey === "financialDetailsData"
                                    ? !["Sanction Limit (Lakhs)", "Current Outstanding Limit (Lakhs)"].includes(el)
                                        ? "text"
                                        : "Number"
                                    : sectionKey === "otherGroupCompaniesData" ? !["Latest FY Turnover (Lakhs)"].includes(el)
                                        ? "text"
                                        : "Number" : null
                            }
                            value={record && record[formattedKey] || ""}
                            onChange={(e) => {
                                handleValueChange(index, e.target.value, formattedKey);
                            }}
                        />
                    );
                }
            });
        });
        columnsOrderedMap = columnsOrderedMap.set("deleteRow", {
            title: "Action",
            dataIndex: "deleteRow",
            key: "deleteRow",
            width: 100,
            align: "center",
            render: (text, record, index) => (
                <Button
                    onClick={() => {
                        this.handleDeleteRow(index, sectionKey);
                    }}
                >
                  Delete
                </Button>
            ),
        });
        return columnsOrderedMap;
    }
      
    getFormFields = () => {
        return (
            (this.state.questionnaire &&
                this.state.questionnaire.size &&
                this.getQuestionnaire(this.state.questionnaire.filter((_, k) => k !== "meta_info")).map((_, k) => {
                    const label = _.label && _.label.includes("↵") ? _.label.split("↵").join("<br />") : _.label;
                    let field = INPUTS.get(_.type);
                    if (_.type == "LABEL") {
                        return {
                            // ...field,
                            type: "LABEL",
                            label: label,
                            placeholder: _.placeholder,
                            // defaultValue: _.response && moment(_.response),
                            formItemLayout: {
                                labelCol: { span: 24 },
                                wrapperCol: { span: 12 }
                            },
                        };
                    }

                    if (_.type == "TEXT") {
                        return {
                            type: "TEXT",
                            label: label,
                            rules: _.required ? [
                                {
                                    required: true,
                                    message: "Field Required"
                                }
                            ] : [],
                            defaultValue: _.response,
                            placeholder: _.placeholder,
                            formItemLayout: {
                                labelCol: { span: 24 },
                                wrapperCol: { span: 12 }
                            },
                        };
                    }
                    
                    if (_.type === "DATE") {
                        return {
                            ...field,
                            label: label,
                            rules: _.required ? [
                                {
                                    required: true,
                                    message: "Field Required"
                                }
                            ] : [],
                            defaultValue: _.response && moment(_.response),
                            formItemLayout: {
                                labelCol: { span: 24 },
                                wrapperCol: { span: 12 }
                            },
                        };
                    }
                    if (_.type === "DATE_MONTH") {
                        return {
                            ...field,
                            label: label, 
                            type: INPUT_TYPES.DATE_MONTH,
                            rules: _.required ? [
                                {
                                    required: true,
                                    message: "Field Required"
                                }
                            ] : [],
                            defaultValue: _.response && moment(_.response),
                            formItemLayout: {
                                labelCol: { span: 24 },
                                wrapperCol: { span: 12 }
                            },
                        };
                    }
                    if (k === "top_brands_dealing_in") {
                        return {
                            label: label,
                            type: INPUT_TYPES.TABLE,
                            title: label,
                            extra: this.BrandBtn,
                            dataSource: _.response,
                            columns: BRANDS_COLS.toList().toArray(),
                            bordered: true,
                            pagination: false
                        };
                    }
                    if (k === "bank_details") {
                        return {
                            label: label,
                            type: INPUT_TYPES.TABLE,
                            title: label,
                            extra: this.BankBtn,
                            dataSource: _.response,
                            columns: BANK_DETAILS_COLS.toList().toArray(),
                            bordered: true,
                            pagination: false
                        };
                    }
                    if (_.type === "MULTI_SELECT") {
                        return {
                            ...field,
                            label: label,
                            options: _.options && _.options.map(__ => ({
                                label: __,
                                value: __
                            })),
                            rules: _.required ? [
                                {
                                    required: true,
                                    message: "Field Required"
                                }
                            ] : [],
                            defaultValue: _.response,
                            formItemLayout: {
                                labelCol: { span: 24 },
                                wrapperCol: { span: 12 }
                            },
                        };
                    }
                    if (_.type === "SELECT") {
                        return {
                            ...field,
                            label: label,
                            options: _.options && _.options.map(__ => ({
                                label: __,
                                value: __
                            })),
                            placeholder: _.placeholder,
                            rules: _.required ? [
                                {
                                    required: true,
                                    message: "Field Required"
                                }
                            ] : [],
                            defaultValue: _.response,
                            formItemLayout: {
                                labelCol: { span: 24 },
                                wrapperCol: { span: 12 }
                            },
                        };
                    }
                    if (_.type === "TABLE") {
                        return {
                            ...field,
                            label: label,
                            columns: _.columns,
                            rules: _.required ? [
                                {
                                    required: true,
                                    message: "Field Required"
                                }
                            ] : [],
                            defaultValue: _.response,
                            formItemLayout: {
                                labelCol: { span: 24 },
                                wrapperCol: { span: 12 }
                            },
                        };
                    }
                    if (["shop_photos", "cheque", "ownership_proof",  "applicant_photo", "personal_details_documents", "shop_office_documents"].includes(k)) {
                        this.docTypes[k] =
                            _.response &&
                            new Map(_.response)
                                .map(__ => ({
                                    label: __.label,
                                    value: __.key,
                                    file: __.file
                                }))
                                .toList()
                                .toArray();
                        return {
                            ...field,
                            label: _.category,
                            rules: _.required ? [
                                {
                                    required: true,
                                    message: "Field Required"
                                }
                            ] : [],
                            defaultValue: _.response,
                            onChange: this.onChange,
                            extra: this.getExtra(k)
                        };
                    }
                    return {
                        ...field,
                        label: label || _.category,
                        options:
                            _.options && _.options.length
                                ? _.options.map(__ => ({
                                    label: __,
                                    value: __
                                }))
                                : [],
                        // onChange: this.onChange(k),
                        // onSelect: this.onSelect(k),
                        defaultValue: _.response,
                        rules: _.required ? [
                            {
                                required: true,
                                message: "Field Required"
                            }
                        ] : [],
                        formItemLayout: {
                            labelCol: { span: 24 },
                            wrapperCol: { span: 12 }
                        },
                        colon: "?"
                    };
                })) ||
            new List([])
        );
    };

    getFormFieldValue = (fieldName, field) => {
        if (fieldName === "Top 5 Brands dealing in") {
            return (
                <ListItem className={"form-field-list-item"} key={fieldName}>
                    {field}
                </ListItem>
            );
        }
        if (this.props.QUESTIONAIRE_EDIT) {
            return (
                <ListItem className={"form-field-list-item"} key={fieldName}>
                    {this.fieldGenerator(
                        fieldName,
                        field,
                        this.getErrorOnField(fieldName)
                    )()}
                </ListItem>
            );
        }
        return this.fieldGenerator(
            fieldName,
            field,
            this.getErrorOnField(fieldName)
        )();
    };

    onSubmitDoc = values => {
        this.setState({
            questionnaire: this.state.questionnaire.withMutations(_ =>
                _.setIn(
                    [this.currentType, "response", values.docType, "file"],
                    [
                        ...this.state.questionnaire.getIn([
                            this.currentType,
                            "response",
                            values.docType,
                            "file"
                        ]),
                        values.fileUrl
                    ]
                )
            ),
            openDocModal: false
        });
    };

    printPD = () => {
        this.props.downloadPDF({
            questionnare: this.state.questionnaire.toJS(),
            ...(this.props.caseData || {})
        });
    }

    refreshPD = async() => {
        const val = await QuestionareService.refreshPDQuestionnaire(this.props.caseId);


        if (val.status == "Success") {
            fetchCaseDetail(this.props.caseId);
            message.success("PD Questionnaire updated!");
        }
        else {
            message.error("Unable to update PD Questionnaire");
        }
        
    }

    tableFn = (fieldName, field, tableData, sectionName) => {
        return (<Form.Item key={fieldName} className={"p-0 d-flex align-items-center"}>
            <Form.Item key={fieldName} className={"p-0 d-flex align-items-center"}>
                <h4 className={"p-0 mt-5 ml-05"}>{field.label}</h4>
            </Form.Item>
            <Table 
                size="middle"
                key="table"
                bordered 
                showTopSection={false}
                data={List(tableData)}
                // dataSource={this.state.financialDetailsData}
                columns={this.renderTableColumns(field, sectionName)} 
                pagination={false}
                className={"inbox-table"}
                showFilters={false}
                showColumnSelector={false}
                noRowSelection={true}
            />
            <Button onClick={()=> this.handleAddRow(field.columns, sectionName)} style={{border:"none", width:"9rem"}}>+ Add New Row</Button>

        </Form.Item>);
    }

    render() {
        return (
            <React.Fragment>
                <Modal
                    visible={this.state.productModal}
                    onCancel={this.toggleProductModal}
                    footer={null}
                    destroyOnClose={true}
                    closable={true}
                >
                    <PDBrandsTable
                        updateBrands={this.updateBrands}
                        products={
                            this.state.questionnaire &&
                            new List(
                                this.state.questionnaire.getIn([
                                    "top_brands_dealing_in",
                                    "response"
                                ]) || []
                            )
                                .toMap()
                                .mapEntries(([, v]) => [v.Brand_Name, v])
                        }
                    />
                </Modal>
                <Modal
                    visible={this.state.bankDetailModal}
                    onCancel={this.toggleBankDetailModal}
                    footer={null}
                    destroyOnClose={true}
                    closable={true}
                >
                    <PDBankDetailsTable
                        updateBrands={this.updateBankDetails}
                        products={
                            this.state.questionnaire &&
                            new List(
                                this.state.questionnaire.getIn([
                                    "bank_details",
                                    "response"
                                ]) || []
                            )
                                .toMap()
                                .mapEntries(([, v]) => [v.Account_Number, v])
                        }
                    />
                </Modal>
                <Modal
                    visible={this.state.openDocModal}
                    onCancel={() =>
                        this.setState({
                            openDocModal: false
                        })
                    }
                    footer={null}
                    destroyOnClose={true}
                    closable={true}
                >
                    <PdDocumentUploadForm
                        onSubmit={this.onSubmitDoc}
                        onSelect={this.onSelectDocType}
                        docTypes={this.docTypes[this.currentType]}
                        companyId={this.props.companyId}
                    />
                </Modal>
                <Card title={"Questionare List"} className={"padless-card"} extra={[
                    <Button key={"refresh-pd"} type={"link"} onClick={this.refreshPD}>Refresh PD</Button>, <Button key={"download-pd"} type={"link"} onClick={this.printPD}>Download</Button>]}>
                    <Form
                        layout={"vertical"}
                        // labelAlign={"left"}
                        className={"p-10 custom-label"}
                        colon={true}
                    >
                        <div>
                            {this.getFormFields()
                                .map((field, fieldName) => {
                                    const personalDetailsDocuments = this.state.questionnaire?.getIn(["personal_details_documents", "response", "proof_doc", "file"]);
                                    const shopOfficeDocuments = this.state.questionnaire?.getIn(["shop_office_documents", "response", "proof_doc", "file"]);
                                    if(fieldName === "additional_details"){
                                        field.label = "";
                                        field.placeholder = "Additional Details";
                                    }

                                    if(fieldName == "anchor_security"){
                                        if(this.props.form.getFieldValue('anchor_security') == "Nil Recourse" && this.props.form.getFieldValue('security_backed_by')){
                                            this.props.form.setFieldsValue({
                                                security_backed_by: null
                                            })
                                        }
                                    }
                                    
                                    if(fieldName == "security_backed_by"){
                                        field.disabled = this.props.form.getFieldValue('anchor_security') == "Nil Recourse"
                                        if(this.props.form.getFieldValue('anchor_security') == "Nil Recourse"){
                                            field.rules = [
                                                {
                                                    required: false,
                                                }
                                            ]
                                        }else{
                                            field.rules = [
                                                {
                                                    required: true,
                                                    message: "Field Required"
                                                }
                                            ]
                                        }
                                       
                                    }
                                    if(personalDetailsDocuments?.length !==0 && fieldName === "personal_details_documents_reason"){
                                        field.disabled = true;
                                    }else if(personalDetailsDocuments?.length ===0 && fieldName === "personal_details_documents_reason") {
                                        field.disabled = false;
                                    }
                                    if(shopOfficeDocuments?.length !==0 && fieldName === "shop_office_documents_reason"){
                                        field.disabled = true;
                                    }else if(shopOfficeDocuments?.length ===0 && fieldName === "shop_office_documents_reason"){
                                        field.disabled = false;
                                    }
                                    if (fieldName === "other_group_companies"){
                                        return this.tableFn(fieldName, field, this.state.otherGroupCompaniesData, "otherGroupCompaniesData");
                                    }
                                    if (field.label === "Financial Details"){
                                        return (<Form.Item key={fieldName} className={"p-0 d-flex align-items-center"} style={{
                                            background: "#e9e9e9"
                                        }}>
                                            <h2 className={"p-0 mt-5 ml-05"}>{field.label}</h2>
                                        </Form.Item>);
                                    }
                                    if (field.label === "Exisiting Borrowings"){
                                        return this.tableFn(fieldName, field, this.state.financialDetailsData, "financialDetailsData");
                                    }
                                    if (field.type === "LABEL"){
                                        return (<Form.Item key={fieldName} className={"p-0 d-flex align-items-center"} style={{
                                            background: "#e9e9e9"
                                        }}>
                                            <h2 className={"p-0 mt-5 ml-05"}>{field.label}</h2>
                                        </Form.Item>);
                                    }
                                    return this.getFormFieldValue(fieldName, field);
                                })
                                .toList()}
                        </div>
                        <div
                            className={
                                "form-row flex-row justify-content-space-between"
                            }
                        >
                            <Form.Item>
                                <Button type={"primary"} onClick={this.submitForm} disabled={this.props.recreditViewOnlyPermission}>
                                    Submit
                                </Button>
                            </Form.Item>
                        </div>
                    </Form>
                </Card>
            </React.Fragment>
        );
    }
}
QuestionareList.propTypes = {
    questionare: PropTypes.object,
    answers: PropTypes.array,
    form: PropTypes.object,
    handleSubmitForm: PropTypes.func,
    QUESTIONAIRE_EDIT: PropTypes.bool,
    companyId: PropTypes.number,
    updateCaseQuestionnaire: PropTypes.func,
    userId: PropTypes.number,
    caseData: PropTypes.object,
    downloadPDF: PropTypes.func,
    caseId : PropTypes.number,
    recreditViewOnlyPermission : PropTypes.bool,
};

const WrappedFormQuestionare = Form.create({
    mapPropsToFields: ({ answers, errors, QUESTIONAIRE_EDIT }) => {
        if (QUESTIONAIRE_EDIT && answers && answers.length > 0) {
            return (
                new List(answers)
                    // .toSeq()
                    .toMap()
                    .mapEntries(([, v]) => [`q-${v.question}`, v.value])
                    .map((value, key) => {
                        return Form.createFormField({
                            value,
                            errors:
                                errors &&
                                    errors.size &&
                                    errors.flatten().get(key)
                                    ? errors.flatten().get(key)
                                    : null
                        });
                    })
                    .toJS()
            );
        }
    }
})(QuestionareList);

// export default PermissionContextManager({
//     permission: UI_PERMISSIONS.QUESTIONAIRE_VIEW,
//     propsPermissions: {
//         QUESTIONAIRE_EDIT: UI_PERMISSIONS.QUESTIONAIRE_EDIT
//     }
// })(WrappedFormQuestionare);
export default WrappedFormQuestionare;
